// The instant filter over the conversations already loaded — what the search
// box shows while the full search (worker: every order, every message) is on
// its way. Same rules as the worker's: order numbers with or without « # »,
// phones by their last 9 digits, names, the stage, the last message; accents
// and case ignored.
//
// Pure. Guard: conversationFilter.test.ts
import type { WhatsAppConversation } from '@/lib/api';

const fold = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ' ').toLowerCase();

/** Two characters at least — one letter matches everything. */
export const searchable = (q: string) => q.trim().length >= 2;

export function matchesConversation(
  c: WhatsAppConversation,
  query: string,
  stageLabel: (stage: string) => string = (s) => s,
): boolean {
  if (!searchable(query)) return false;
  const q = fold(query.trim()).replace(/^#/, '');
  const fields = [c.name, c.order_name?.replace(/^#/, ''), c.stage, c.stage ? stageLabel(c.stage) : null, c.last_body]
    .filter((x): x is string => Boolean(x))
    .map(fold);
  if (fields.some((f) => f.includes(q))) return true;

  const digits = query.replace(/\D/g, '');
  if (digits.length >= 6) {
    const last9 = digits.slice(-9);
    const phone = String(c.phone ?? '').replace(/\D/g, '');
    if (phone.includes(last9)) return true;
    if (c.chat_id.endsWith('@c.us') && c.chat_id.replace(/\D/g, '').includes(last9)) return true;
  }
  return false;
}
